export default __webpack_public_path__ + "static/12-213edc4ae60cdb816de3624e39530b91.jpg";